import { IconX } from '@tabler/icons-react';

import { UnstyledButton } from '~/domains/design-system/Button';
import { useIsMobile } from '~/domains/common/hooks/mediaQueries';

import LogoWhale from '~/domains/design-system/vectors/LogoWhale';
import LogoText from '~/domains/design-system/vectors/LogoText';

import useStyles from './UserMenu.styles';
import UserNavLink from './UserNavLink';
import UserDetailBox from './UserDetailBox';
import useUserMenu from './useUserMenu';
import type { UserMenuProps } from './types';

function UserMenu({
  user,
  onClose,
  KYCStatus,
  notificationsCount,
  cashBalance,
  balance,
  credits,
  refundableBalance,
  playthroughCash,
  handleOpenWithdrawalModal,
  handleOpenDepositModal,
  isLoading,
  isProtectionLoading,
}: UserMenuProps) {
  const { classes, theme } = useStyles();
  const menuConfig = useUserMenu({
    user,
    KYCStatus,
    notificationsCount,
  });
  const isTablet = useIsMobile();

  return (
    <>
      <div className={classes.userMenuContainer}>
        {isTablet && (
          <div className={classes.userMenuHeader}>
            <LogoWhale />
            <LogoText color={theme.colors.gray2[6]} />
            <UnstyledButton className={classes.closeButton} onClick={onClose}>
              <IconX size={20} color={theme.colors.gray2[3]} />
            </UnstyledButton>
          </div>
        )}
        <div className={classes.userMenuContent}>
          <UserDetailBox
            user={user}
            KYCStatus={KYCStatus}
            cashBalance={cashBalance}
            balance={balance}
            credits={credits}
            refundableBalance={refundableBalance}
            playthroughCash={playthroughCash}
            handleOpenWithdrawalModal={handleOpenWithdrawalModal}
            handleOpenDepositModal={handleOpenDepositModal}
            isLoading={isLoading}
            isProtectionLoading={isProtectionLoading}
          />
          <div className={classes.userNavContainer}>
            {menuConfig?.map((item) => {
              if (typeof item === 'string') return <div className={classes.userNavDivider} />;
              return <UserNavLink key={item.text} {...item} />;
            })}
          </div>
        </div>
      </div>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div className={classes.userMenuBackdrop} onClick={onClose} />
    </>
  );
}

export default UserMenu;
